import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'

export interface IWindowState {
  isActive: boolean
}

export const initialWindowState: IWindowState = {
  isActive: true,
}

const windowAdapter = createEntityAdapter()

export const windowSlice = createSlice({
  name: 'window',
  initialState: windowAdapter.getInitialState(initialWindowState),
  reducers: {
    setWindowIsActive: (state, action: PayloadAction<boolean>) => {
      state.isActive = action.payload
    },
  },
})

export const { setWindowIsActive } = windowSlice.actions

export const { selectAll: windowSelector } = windowAdapter.getSelectors(
  (state: RootState) => state[windowSlice.name],
)

export const selectWindowState = (state: RootState) => state.window
export const selectWindowIsActive = (state: RootState) => state.window.isActive
